import { BuildClass } from '../../../../universal';
import { React } from '../../../lib';
import { Checkbox } from '../checkbox';
import { CJSX } from '../meta-types';
import { getIsPrivilegedView, getVisibilityText } from './utils';
export const ChatComposer = (props) => {
    const rs = props.rs;
    const isPrivilegedView = getIsPrivilegedView(rs.props);
    const visibilityText = getVisibilityText(rs.props);
    if (rs.props.isReadOnly) {
        return (React.createElement("div", { ref: rs.refs.composerWrapper, className: "mt-auto sticky bottom-0 z-20 p-3", onMouseDownCapture: props.onPaneMouseDownCapture },
            React.createElement("div", { className: "mx-auto w-full max-w-[800px]" },
                React.createElement("div", { className: BuildClass([
                        'rounded-xl border border-[oklch(var(--chat-l-text)_0_0_/_0.2)]',
                        'bg-[oklch(var(--chat-l-surface)_0_0_/_0.94)] px-3 py-2 text-sm',
                        'text-[oklch(var(--chat-l-text-muted)_0_0)]',
                        'shadow-[0_1px_2px_rgba(0,0,0,0.04)]',
                    ]) }, rs.props.readOnlyMessage ?? 'This thread is read-only.'),
                React.createElement(CJSX, { cond: Boolean(rs.state.error) },
                    React.createElement("div", { className: "mt-2 text-sm text-[oklch(0.47_0.16_25)]" }, rs.state.error)))));
    }
    return (React.createElement("div", { ref: rs.refs.composerWrapper, className: "mt-auto sticky bottom-0 z-20 p-3", onMouseDownCapture: props.onPaneMouseDownCapture, onClick: props.onPaneClick },
        React.createElement("div", { className: "mx-auto w-full max-w-[800px]" },
            React.createElement(CJSX, { cond: isPrivilegedView && rs.state.canControlVisibility },
                React.createElement("div", { className: "mb-2" },
                    React.createElement("div", { className: BuildClass([
                            'inline-flex items-center gap-2 rounded-2xl border',
                            'border-[oklch(var(--chat-l-text)_0_0_/_0.16)]',
                            'bg-[oklch(var(--chat-l-surface)_0_0_/_0.86)] px-2.5 py-1',
                            'text-sm shadow-[0_1px_2px_rgba(0,0,0,0.08)]',
                        ]) },
                        React.createElement(Checkbox, { value: rs.state.visibleToTarget, onUpdate: value => {
                                rs.updateState({ visibleToTarget: value });
                            }, lbl: "" }),
                        React.createElement("span", { className: BuildClass({
                                'inline-flex cursor-pointer select-none items-center': true,
                                'text-[oklch(var(--chat-l-accent)_var(--chat-c-accent)_var(--chat-hue))]': rs.state.visibleToTarget,
                                'text-[oklch(var(--chat-l-text-muted)_0_0)]': !rs.state.visibleToTarget,
                            }), onClick: () => {
                                rs.updateState(s => ({
                                    visibleToTarget: !s.visibleToTarget,
                                }));
                            }, "data-chat-interactive": "true" }, rs.state.visibleToTarget
                            ? visibilityText.composeVisibleToTarget
                            : visibilityText.composeHiddenFromTarget)))),
            React.createElement("div", { className: BuildClass([
                    'relative overflow-hidden rounded-2xl border',
                    'border-[oklch(var(--chat-l-text)_0_0_/_0.18)]',
                    'bg-[oklch(var(--chat-l-surface)_0_0)]',
                    'shadow-[0_1px_2px_rgba(0,0,0,0.05)]',
                ]) },
                React.createElement("textarea", { ref: rs.refs.textarea, rows: 1, className: BuildClass([
                        'w-full resize-none bg-transparent py-2.5 pl-3 pr-14 text-base',
                        'text-[oklch(var(--chat-l-text)_0_0)]',
                        'placeholder:text-[oklch(var(--chat-l-text-muted)_0_0)]',
                        'focus:outline-none',
                    ]), style: {
                        minHeight: '44px',
                        maxHeight: '200px',
                    }, value: rs.state.messageText, onChange: props.onTextboxChange, onKeyDown: props.onTextboxKeyDown, placeholder: "Type your message...", disabled: rs.state.sending || rs.state.loading }),
                React.createElement("div", { className: "absolute right-1.5 top-1/2 z-20 -translate-y-1/2" },
                    React.createElement("button", { type: "button", onClick: props.onSendMessage, disabled: !props.canSendMessage || rs.state.loading, className: BuildClass({
                            'flex h-8 w-8 items-center justify-center rounded-full transition-all': true,
                            'bg-[oklch(var(--chat-l-accent)_var(--chat-c-accent)_var(--chat-hue))]': props.canSendMessage,
                            'text-white': props.canSendMessage,
                            'hover:bg-[oklch(var(--chat-l-accent)_var(--chat-c-accent)_var(--chat-hue)_/_0.9)]': props.canSendMessage,
                            'cursor-not-allowed': !props.canSendMessage,
                            'bg-[oklch(var(--chat-l-text)_0_0_/_0.16)]': !props.canSendMessage,
                            'text-[oklch(var(--chat-l-text)_0_0_/_0.42)]': !props.canSendMessage,
                        }), title: "Send message" },
                        React.createElement("svg", { className: "h-[16px] w-[16px]", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", strokeWidth: 2.5 },
                            React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M5 10l7-7m0 0l7 7m-7-7v18" }))))),
            React.createElement(CJSX, { cond: Boolean(rs.state.error) },
                React.createElement("div", { className: "mt-2 text-sm text-[oklch(0.47_0.16_25)]" }, rs.state.error)))));
};
//# sourceMappingURL=composer.js.map